import React from 'lib/react';
import {
  EVGrid, EVCheckbox,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import PropTypes from 'prop-types';
import { useSelector } from 'lib/redux';
import { getReportFormatOptions } from 'features/orderPreferences/OrderPreferences.utils';
import ProductAddonsStyles from '../ProductAddonsStyles';

function ProductAddonsReportsFormat(props) {
  const { t } = useTranslation();
  const classes = ProductAddonsStyles();

  const {
    subKey, handleChange,
  } = props;

  const orderPreferences = useSelector(({ userData }) => userData.orderPreferences);

  const inputFieldValues = useSelector(({ orderPreference }) => orderPreference.inputFieldValues);

  const addonsReportFormatFieldProps = getReportFormatOptions(subKey, orderPreferences, inputFieldValues);

  return (
    <EVGrid className={classes.addonsElementsCB2}>
      {addonsReportFormatFieldProps.map(({
        text, id, key, subkey, ...fieldProps
      }) => (
        <EVGrid className={classes.addonsElementsCB} key={id}>
          <EVCheckbox
            id={id}
            {...fieldProps}
            onChange={handleChange(key, subkey)}
            color="primary"
            className={classes.checkChanges}
          />
          <label className={classes.propertyOwnerText} htmlFor={id}>{t(text)}</label>
        </EVGrid>
      ))}
    </EVGrid>
  );
}

ProductAddonsReportsFormat.propTypes = {
  handleChange: PropTypes.func.isRequired,
  subKey: PropTypes.string.isRequired,
};

export default ProductAddonsReportsFormat;
